'use strict';

define(['app', 'columboConfig', 'columboEvents', 'columboMetrics', 'siteObj', '$console'], function (app, columboConfig, columboEvents, columboMetrics, siteObj, $console) {
  var Columbo = function Columbo() {
    var module = {};
    var _columboEvents = columboEvents();
    var _columboMetrics = columboMetrics();

    var _init = function _init() {
      module.fastenEvents();
      module.fastenPages();
      module.columboEvents.elementClicked(module.getByTriggerType('componentClicked'), module.publishEvent);
      module.columboEvents.elementViewed(module.getByTriggerType('componentViewed'), module.publishEvent);
      module.columboEvents.elementFocused(module.getByTriggerType('componentFocused'), module.publishEvent);
      module.columboEvents.elementHovered(module.getByTriggerType('componentHovered'), module.publishEvent);
      module.columboEvents.createCustomDivSpies(module.filterByTriggerType('spy'));
    };

    var _getByTriggerType = function _getByTriggerType(triggerType) {
      return columboConfig.find(function (configElement) {
        return configElement.trigger.type === triggerType;
      });
    };

    var _filterByTriggerType = function _filterByTriggerType(triggerType) {
      return columboConfig.filter(function (configElement) {
        return configElement.trigger.type === triggerType;
      });
    };

    var _fastenEvents = function _fastenEvents() {
      return module.filterByTriggerType('event').map(function (configElement) {
        return module.fastenEvent(configElement);
      });
    };

    var _fastenPages = function _fastenPages() {
      return module.filterByTriggerType('page').map(function (configElement) {
        return module.fastenPage(configElement);
      });
    };

    var _fastenEvent = function _fastenEvent(configElement) {
      app.subscribe(configElement.trigger.event, function () {
        module.publishEvent(configElement, arguments);
      });
    };

    var _fastenPage = function _fastenPage(configElement) {
      if (module.isDocumentLoaded(configElement.trigger.event)) {
        module.publishEvent(configElement);
      } else {
        window.addEventListener(configElement.trigger.event, function () {
          return module.publishEvent(configElement);
        });
      }
    };

    var _isDocumentLoaded = function _isDocumentLoaded(event) {
      return event === 'load' && document.readyState === 'complete';
    };

    var _publishEvent = function _publishEvent(configElement) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var eventData = module.columboMetrics.getMetrics(configElement.publish.metrics, args);

      if (siteObj.debugFlag) {
        $console.log('%cColumbo Event: "' + configElement.publish.event + '"', 'background: #222; color: #bada55', eventData);
      }

      eventData.key = configElement.key;
      app.publish(configElement.publish.event, eventData);
    };

    module.columboEvents = _columboEvents;
    module.columboMetrics = _columboMetrics;
    module.columboConfig = columboConfig;
    module.fastenEvents = _fastenEvents;
    module.fastenPages = _fastenPages;
    module.fastenEvent = _fastenEvent;
    module.fastenPage = _fastenPage;
    module.filterByTriggerType = _filterByTriggerType;
    module.getByTriggerType = _getByTriggerType;
    module.init = _init;
    module.isDocumentLoaded = _isDocumentLoaded;
    module.publishEvent = _publishEvent;

    module.init();
    return module;
  };

  return Columbo();
});
//# sourceMappingURL=columbo.js.map
